import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import HotSwapLocations from './how-swap-summary-locations'
import HotSwapSummaryDetails from './how-swap-summary-details'

export default function HotSwapSummary({
    selectedHotSwapLocations,
    formData,
    swapType,
    scheduledDate,
    scheduledTime
}) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    return (
        <div className={classes.container}>
            <HotSwapLocations
                locale={locale}
                selectedHotSwapLocations={selectedHotSwapLocations}
                showChangeLocation={!formData}
            />
            {formData && (
                <HotSwapSummaryDetails
                    formData={formData}
                    scheduledDate={scheduledDate}
                    scheduledTime={scheduledTime}
                    swapType={swapType}
                    locale={locale}
                />
            )}
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        padding: '30px 25px 25px 25px',
        minWidth: '340px',
        gap: '1rem',
        borderRadius: theme.borderRadius,
        border: '1px solid #EAECF0',
        boxShadow:
            '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)'
    }
}))
